export default __webpack_public_path__ + "assets/ebe1d7ec90c778f68b2885a70034b977.woff";